export default {"src":"/_next/static/media/engine.58925e8b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};